"use client";

import { c as _c } from "react/compiler-runtime";
import { MagnusProvider } from "@magnus/react/provider";
import { useSession } from "@workspace/auth/client";
import type { AppSurface } from "@workspace/services/domain";
import { type ReactNode, useMemo } from "react";
import { magnusClient } from "@/lib/magnus-client";
import { getOfficeClientTools } from "@/lib/office/client-tools";

/**
 * Mounts the Magnus SDK provider for the app, registering the current
 * surface's client tools (Office tools on add-in surfaces; none on the
 * standalone web surface). Memoized per host so the context value is stable.
 */
export function MagnusAppProvider(t0) {
  const $ = _c(7);
  const {
    host,
    children
  } = t0;
  let t1;
  if ($[0] !== host) {
    t1 = getOfficeClientTools(host);
    $[0] = host;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const tools = t1;
  const {
    data: session
  } = useSession();
  const viewerId = session?.user.id;
  let t2;
  if ($[2] !== children || $[3] !== host || $[4] !== tools || $[5] !== viewerId) {
    t2 = <MagnusProvider client={magnusClient} surface={host} tools={tools} viewerId={viewerId}>{children}</MagnusProvider>;
    $[2] = children;
    $[3] = host;
    $[4] = tools;
    $[5] = viewerId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}